<template>
    <div class='question'>
        <div class='question_item' v-for='(item,index) in list' @click='changeActive(index)' :class='{active:index === activeIndex}'>
            <div class='question_title'>
                <span>Q</span>
                <div>: {{item.title}}</div>
                <img src='/images/base/right_row.png' class='img_row'>
            </div>
            <div class='question_cont' v-html='item.dero' v-show='activeIndex == index'>

            </div>
        </div>
    </div>
</template>

<script>
    import zhugeObj from '@/assets/js/track'
    export default {
        name: "question",
        props:{

        },
        data() {
        return {
            list : [
                {
                    title : '修复包包需要什么流程？',
                    dero : '→收到宝贝后，会短信告知</br>→签收开单，2-4个工作日左右发诊断修复方案给你</br>→确认修复方案并付款（微信优先，支付宝，网银均可）</br>→小跑进入开工阶段（具体时间要看修复项）</br>→修复完成并质检通过，入库</br>→确认修复方案，有问题直接跟养护顾问沟通完善修复，没有问题，填写地址，确认送回</br>'
                },
                {
                    title : '怎么取送？',
                    dero : '包拯在全国' + (this.$store.state.takeSendNum - 3) + '座城市（'+ this.$store.state.takeSendCity + '）可安排专属的取件小哥上门取件，具体的取件范围可联系专属客服为您解答'
                },
                {
                    title : '会员充值有什么优惠？',
                    dero : '会员制度</br>充值3000送200</br>充值6000送800（性价比最高）</br>充值9000送1000'
                },
                {
                    title : '怎么查看我的订单？',
                    dero : '您微信搜索🔍关注包拯公众号“baozheng0618”，登陆您当时预留的手机号码可查询到物品修复进度状况'
                },
                {
                    title : '怎么保证我物品的安全？',
                    dero : '包拯成立了五周年拥有3000多平米的修复中心，并且拥有将近几百人的团队；心爱之物到大人府上后，我们会使用唯一标识码确保不会弄混哒，各个工序都有高清摄像头监控👀。包包寄回过程中，有快递或物流跟踪'
                },
                {
                    title : '价格会不会发生变化？',
                    dero : '包拯修复物品是按照单独服务项收费是绝对不会乱收费的，您的物品到达修复中心后顾问老师会根据实物进行诊断'
                },
            ],
            activeIndex : null
        }
        },
        watch: {
        
        },
        filters:{
        
        },
        computed: {
        
        },
        directives : {

        },
        created() {
        },
        mounted() {
        },
        methods: {
            changeActive(index){
                zhugeObj.track({
                    title : '方案袋-常见问题',
                    content : {
                        '问题' : this.list[index].title
                    }
                })
                if(this.activeIndex == index){
                    this.activeIndex = null;
                }else{
                    this.activeIndex = index;
                }
            
            }
        }
        
    }
</script>

<style scoped lang="scss">
    .question_item{
        margin-top: 30px;

        border-bottom:1px solid #EEEEEE;
        padding-bottom:30px;
        max-height: 37px;
        transition: all ease 0.5s;
        .question_title{
            display: flex;
            line-height: 36px;
            color:#9B9B9B;
            font-size: 28px;
            position: relative;
            span{
                width: 36px;
                height: 36px;
                background: #4A4A4A!important;
                color:#fff!important;
                display: block;
                line-height: 36px;
                border-radius:50%;
                text-align: center;
                margin-right: 20px;
            }
            img{
                width:14px;
                height: 24px;
                position: absolute;
                right: 0px;
                top:5px;
                transition: all ease 0.3s;
            }
        }
        .question_cont{
            color:#9B9B9B;
            font-size: 24px;
            padding-left: 60px;
            line-height: 35px;
            margin-top: 30px;
        }
    }
    .active{
        max-height: 800px;
        .img_row{
            transform:rotate(90deg)!important;
        }
    }

</style>
